interface LoggedOutProps {
  /** Clears the logged-out flag and resumes the login flow for the active provider. */
  onSignIn: () => void
}

/**
 * Full-screen "You've been signed out" landing shown after an explicit logout.
 *
 * Its sole job is to give the user a place to land that is exempt from
 * RequireAuth's auto-relogin effect. The IdP federated session is intentionally
 * left intact (see the logout-landing-page design), so "Sign in again" may take
 * SSO users straight back in — that is expected for this scope.
 */
export function LoggedOut({ onSignIn }: LoggedOutProps) {
  return (
    <div className="logged-out">
      <style>{`
        .logged-out {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          min-height: 100vh;
          width: 100vw;
          position: fixed;
          top: 0;
          left: 0;
          background: var(--color-bg-primary);
          color: var(--color-text-secondary);
          gap: 20px;
          z-index: 9999;
          padding: 24px;
          box-sizing: border-box;
        }
        .logged-out h1 {
          font-size: 20px;
          font-weight: 600;
          color: var(--color-text-primary);
          margin: 0;
        }
        .logged-out p {
          font-size: 14px;
          margin: 0;
          text-align: center;
          max-width: 360px;
        }
        .logged-out button {
          margin-top: 4px;
        }
      `}</style>
      <h1>You've been signed out</h1>
      <p>Your session on this device has ended.</p>
      <button className="btn btn-primary" onClick={onSignIn}>
        Sign in again
      </button>
    </div>
  )
}

export default LoggedOut
